import React, { useEffect, useState } from 'react'
import './Career.css'
import img from '../../Images/Group (4).png'
import FeaturedJobs from './FeaturedJobs'
import imgbg from '../../Images/Group 1171279366 (4).png'
import HomeService from '../../Services/HomeService'
import { toast } from 'react-toastify'
const PopularJob = ({ filterData, listingTitle }) => {
    console.log("KKL9", filterData);

    const [jobListingTitle, setJobListingTitle] = useState(listingTitle)
    const [jobCategories, setJobCategories] = useState([])
    const [jobPosts, setJobPosts] = useState([])
    const [currentJobCategory, setCurrentJobCategory] = useState("")
    const [loading, setLoading] = useState(false)

    const fetchAllJobCategories = async () => {
        try {
            const res = await HomeService.getJobCategories();
            if (res?.status) {
                console.log("YTR16", res.data);
                setCurrentJobCategory(res.data.filter(item => item.status)[0]?._id)
                setJobCategories(res.data.filter(item => item.status));
            }
        } catch (error) {
            toast.error("Failed to add property.");
            console.error("Error adding property:", error);
        }
    }

    const fetchAllJobPostsByCategories = async (id) => {
        setLoading(true)
        // setJobListingTitle("Featured Jobs")
        try {
            const res = await HomeService.getJobPostsByCategoryId(id);
            if (res?.status) {

                let jobData = res.data
                if (filterData.city && filterData.city.trim() !== "") {
                    jobData = jobData.filter(item =>
                        item.location.toLowerCase().includes(filterData?.city.toLowerCase())
                    );
                }
                console.log("SDC43", jobData, id, filterData?.city);
                setJobPosts(jobData);
                setLoading(false)
            }
        } catch (error) {
            toast.error("Failed to add property.");
            console.error("Error adding property:", error);
        }
    }

    useEffect(() => {
        filterData?.category && fetchAllJobPostsByCategories(filterData?.category)

    }, [filterData])

    useEffect(() => {
        currentJobCategory ? fetchAllJobPostsByCategories(currentJobCategory) : setJobPosts([])
    }, [currentJobCategory])

    useEffect(() => {
        fetchAllJobCategories()
    }, [])

    return (
        <section className='popular_section'>
            <img className='img-bg-popular' src={imgbg} />
            <div className='popular_wrapper'>
                <h1>Popular Job Category</h1>
                <div className='popular_card_wrapper'>

                    {
                        jobCategories.length > 0 &&
                        jobCategories.map((item, key) => {
                            return (
                                <>
                                    <div className={currentJobCategory === item?._id ? "popular_card active-cate" : "popular_card"}
                                        onClick={() => setCurrentJobCategory(item?._id)}
                                    >
                                        <div className='popular_img'>
                                            <img src={img} />
                                        </div>
                                        <h4 className='text-light'>{item?.catName}</h4>
                                        <p className='jobs_para text-light'>{item?.jobPostCount || 0} Job{parseInt(item?.jobPostCount) > 1 ? "s" : ""}</p>
                                        <p className='popular_para2 text-light'>{item?.description || ""}</p>
                                    </div>
                                </>
                            )
                        })
                    }



                    {/* <div className='popular_card2'>
                        <div className='popular_img'>
                            <img src={img} />
                        </div>
                        <h4>Marketing & Sales</h4>
                        <p className='jobs_para'>16 Jobs</p>
                        <p className='popular_para2'>Lorem Ipsum is a dummy or placeholder text commonly</p>
                    </div>
                    <div className='popular_card2'>
                        <div className='popular_img'>
                            <img src={img} />
                        </div>
                        <h4>Accounts</h4>
                        <p className='jobs_para'>16 Jobs</p>
                        <p className='popular_para2'>Lorem Ipsum is a dummy or placeholder text commonly</p>
                    </div>
                    <div className='popular_card2'>
                        <div className='popular_img'>
                            <img src={img} />
                        </div>
                        <h4>Graphics & Design</h4>
                        <p className='jobs_para'>16 Jobs</p>
                        <p className='popular_para2'>Lorem Ipsum is a dummy or placeholder text commonly</p>
                    </div> */}




                </div>
            </div>
            <FeaturedJobs data={jobPosts} loading={loading} listingTitle={jobListingTitle} />

        </section>
    )
}

export default PopularJob
